export const SEX_LIST = [
  {
    label: '여자',
    value: '2'
  },
  {
    label: '남자',
    value: '1'
  },
]

export const OFFICE_LIST = [
  {
    label: '재직',
    value: '1'
  },
  {
    label: '퇴사',
    value: '0'
  },
]
export const LOCAL_LIST = [
  {
    label: '내국인',
    value: '1'
  },
  {
    label: '외국인',
    value: '2'
  },
]
export const ISKOREA_LIST = [
  {
    label: '한국',
    value: '1'
  },
  {
    label: '외국',
    value: '0'
  },
]